// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3GSMt","signatureBlock":"Footer_signatureBlock__2IIyj","signature":"Footer_signature__2XNnM"};